import React, { useContext, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import "../styles/AccountSettingsPage.css";
import { AuthContext } from "../auth/AuthContext";
import Navbar  from "../components/Navbar.jsx";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function AccountSettingsPage({
  email = "user@example.com",
  isOrganizerVerified = false,
  onDeleteAccount,
}) {
  const { user, accessToken, logout } = useContext(AuthContext);

  // --- STAN DLA MODALI I FORMULARZY ---

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  // zmiana e-maila
  const [newEmail, setNewEmail] = useState(user?.email || "");
  const [emailPassword, setEmailPassword] = useState("");
  const [emailLoading, setEmailLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [emailSuccess, setEmailSuccess] = useState("");

  // zmiana hasła
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState("");

  // usuwanie konta
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletePassword, setDeletePassword] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteError, setDeleteError] = useState("");

  // 🔴 DOPIERO TERAZ early return – po wszystkich hookach
  if (!user || !accessToken) {
    return <Navigate to="/" replace />;
  }

  // --- HANDLERY ZMIANY E-MAILA ---

  const handleOpenEmailModal = () => {
    setEmailError("");
    setEmailSuccess("");
    setEmailPassword("");
    setNewEmail(user.email || "");
    setShowEmailModal(true);
  };

  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
  };

  const handleSubmitChangeEmail = async (e) => {
    e.preventDefault();
    setEmailError("");
    setEmailSuccess("");
    setEmailLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/users/change-email/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          password: emailPassword,
          new_email: newEmail,
        }),
      });

      if (res.ok) {
        const data = await res.json();
        setEmailSuccess(data.detail || "Adres e-mail został zmieniony.");
        setEmailPassword("");
      } else {
        let msg = "Nie udało się zmienić adresu e-mail.";
        try {
          const data = await res.json();
          if (data.new_email && Array.isArray(data.new_email)) {
            msg = data.new_email[0];
          } else if (data.password && Array.isArray(data.password)) {
            msg = data.password[0];
          } else if (data.detail) {
            msg = data.detail;
          }
        } catch (err) {}
        setEmailError(msg);
      }
    } catch (err) {
      setEmailError("Wystąpił błąd sieci. Spróbuj ponownie.");
    } finally {
      setEmailLoading(false);
    }
  };

  // --- HANDLERY ZMIANY HASŁA ---

  const handleOpenPasswordModal = () => {
    setPasswordError("");
    setPasswordSuccess("");
    setOldPassword("");
    setNewPassword("");
    setNewPasswordConfirm("");
    setShowPasswordModal(true);
  };

  const handleClosePasswordModal = () => {
    setShowPasswordModal(false);
  };

  const handleSubmitChangePassword = async (e) => {
    e.preventDefault();
    setPasswordError("");
    setPasswordSuccess("");
    setPasswordLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/users/change-password/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          old_password: oldPassword,
          new_password: newPassword,
          new_password_confirm: newPasswordConfirm,
        }),
      });

      if (res.ok) {
        const data = await res.json();
        setPasswordSuccess(data.detail || "Hasło zostało zmienione.");
        setOldPassword("");
        setNewPassword("");
        setNewPasswordConfirm("");
      } else {
        let msg = "Nie udało się zmienić hasła.";
        try {
          const data = await res.json();
          if (data.old_password && Array.isArray(data.old_password)) {
            msg = data.old_password[0];
          } else if (
            data.new_password_confirm &&
            Array.isArray(data.new_password_confirm)
          ) {
            msg = data.new_password_confirm[0];
          } else if (data.new_password && Array.isArray(data.new_password)) {
            msg = data.new_password[0];
          } else if (data.detail) {
            msg = data.detail;
          }
        } catch (err) {}
        setPasswordError(msg);
      }
    } catch (err) {
      setPasswordError("Wystąpił błąd sieci. Spróbuj ponownie.");
    } finally {
      setPasswordLoading(false);
    }
  };

  const handleOpenDeleteModal = () => {
  setDeletePassword("");
  setDeleteError("");
  setShowDeleteModal(true);
};

const handleCloseDeleteModal = () => {
  setShowDeleteModal(false);
};

const handleSubmitDeleteAccount = async (e) => {
  e.preventDefault();
  setDeleteError("");
  setDeleteLoading(true);

  try {
    const res = await fetch(`${API_BASE}/api/users/delete-account/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ password: deletePassword }),
    });

    if (res.ok) {
      // konto usunięte – wyloguj usera i przekieruj
      logout && logout();
      window.location.href = "/"; // twardy redirect na stronę główną
    } else {
      let msg = "Nie udało się usunąć konta.";
      try {
        const data = await res.json();
        if (data.password && Array.isArray(data.password)) {
          msg = data.password[0];
        } else if (data.detail) {
          msg = data.detail;
        }
      } catch (err) {}
      setDeleteError(msg);
    }
  } catch (err) {
    setDeleteError("Wystąpił błąd sieci. Spróbuj ponownie.");
  } finally {
    setDeleteLoading(false);
  }
};


  return (
    <>
      <div className="account-settings-page">
        <Navbar variant="default" />
        <div className="container py-4 py-lg-5">
          {/* Tytuł + opis */}
          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-4">
            <div>
              <h3 className="fw-semibold mb-1">
                <i className="bi bi-person-gear me-2"></i>
                Ustawienia konta
              </h3>
              <p className="text-muted small mb-0">
                Zarządzaj swoim kontem, bezpieczeństwem i prywatnością na
                Siedzieje.
              </p>
            </div>
            <Link
                to="/"
                className="btn btn-sm btn-outline-secondary rounded-pill px-3"
              >
                <i className="bi bi-arrow-left-short me-1" />
                Wróć do wydarzeń
              </Link>
          </div>

          <div className="row g-4">
            {/* Lewa kolumna */}
            <div className="col-12 col-lg-8">
              {/* SEK CJA: KONTO */}
              <div className="settings-card border-0 shadow-sm rounded-4 mb-3 settings-card">
                <div className="settings-card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="settings-section-title mb-0">Konto</h5>
                  </div>

                  <div className="settings-row">
                    <div className="settings-label">E-mail</div>
                    <div className="settings-value">{user.email}</div>
                  </div>

                  {/* <div className="settings-row">
                    <div className="settings-label">
                      Status profilu organizatora
                    </div>
                    <div className="settings-value">
                      {isOrganizerVerified ? (
                        <span className="badge bg-success-subtle text-success-emphasis rounded-pill">
                          <i className="bi bi-patch-check-fill me-1"></i>
                          Zweryfikowany organizator
                        </span>
                      ) : (
                        <span className="badge bg-warning-subtle text-warning-emphasis rounded-pill">
                          <i className="bi bi-hourglass-split me-1"></i>
                          Profil organizatora niezweryfikowany
                        </span>
                      )}
                    </div>
                  </div> */}
                </div>
              </div>

              {/* SEKCJA: BEZPIECZEŃSTWO */}
              <div className="settings-card border-0 shadow-sm rounded-4 mb-3 settings-card">
                <div className="settings-card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="settings-section-title mb-0">
                      Bezpieczeństwo
                    </h5>
                  </div>

                  <p className="text-muted small mb-3">
                    Dbamy o bezpieczeństwo Twojego konta. Regularnie aktualizuj
                    hasło i upewnij się, że masz dostęp do aktualnego adresu
                    e-mail.
                  </p>

                  <div className="d-flex flex-column flex-md-row gap-2">
                    <button
                      type="button"
                      className="btn btn-outline-primary rounded-pill flex-fill text-start text-md-center"
                      onClick={handleOpenEmailModal}
                    >
                      <i className="bi bi-envelope-edit me-2"></i>
                      Zmień e-mail
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-primary rounded-pill flex-fill text-start text-md-center"
                      onClick={handleOpenPasswordModal}
                    >
                      <i className="bi bi-shield-lock me-2"></i>
                      Zmień hasło
                    </button>
                  </div>
                </div>
              </div>

              {/* SEKCJA: PRYWATNOŚĆ / DANE */}
              <div className="settings-card border-0 shadow-sm rounded-4 mb-3 settings-card">
                <div className="settings-card-body">
                  <h5 className="settings-section-title mb-2">
                    Prywatność / dane
                  </h5>
                  <p className="small text-muted mb-2">
                    • Twoje dane wykorzystujemy wyłącznie do działania i ulepszania Siedzieje.
                  </p>
                  <p className="small text-muted mb-2">
                    • Nie potrzebujemy i nie przetwarzamy zbędnych danych osobowych.
                  </p>
                  <p className="small text-muted mb-2">
                    • Twój profil Siedzieje jest widocznych dla innych użytkowników (tło, opis, nazwa), natomiast:
                  </p>

                  <div className="d-flex align-items-start gap-2 mb-2">
                    {/* <i className="bi bi-eye-slash text-primary mt-1"></i> */}
                    <p className="mb-0 small">
                      <strong>• adres email oraz obserwowane wydarzenia są prywatne.</strong> Nikt
                      poza Tobą nie widzi listy Twoich obserwowanych eventów.
                    </p>
                  </div>

                  {/* <p className="small text-muted mb-0">
                    W przyszłości dodamy więcej opcji kontroli nad Twoimi
                    danymi (eksport, usuwanie historii itp.).
                  </p> */}
                </div>
              </div>

              {/* USUŃ KONTO */}
              <div className="settings-card border-0 shadow-sm rounded-4 mb-3 settings-card">
                <div className="settings-card-body">
                  <div>
                    <h6 className="mb-1 text-danger">Usuń konto</h6>
                    <p className="small text-muted mb-0">
                      Usunięcie konta spowoduje trwałe usunięcie Twoich danych,
                      zapisanych wydarzeń i historii. Tej operacji nie można
                      cofnąć.
                    </p>
                  </div>
                  <div className="d-flex flex-column flex-md-row gap-2 padding-top-2">
                    <button
                      type="button"
                      className="btn btn-outline-danger rounded-pill"
                      onClick={handleOpenDeleteModal}
                    >
                      <i className="bi bi-trash3 me-2"></i>
                      Usuń konto
                    </button>
                  </div>
                </div>
                
              </div>

              
            </div>

            {/* Prawa kolumna – info */}
            {/* <div className="col-12 col-lg-4">
              <div className="settings-card border-0 shadow-sm rounded-4 settings-card">
                <div className="settings-card-body">
                  <h6 className="fw-semibold mb-2">Wskazówki bezpieczeństwa</h6>
                  <ul className="small text-muted mb-0 ps-3">
                    <li>Używaj unikalnego hasła do Siedzieje.</li>
                    <li>Nie udostępniaj danych logowania innym osobom.</li>
                    <li>
                      Jeśli podejrzewasz nieautoryzowany dostęp do konta,
                      natychmiast zmień hasło.
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* MODAL: ZMIANA E-MAILA */}
{showEmailModal && (
  <>
    <div
      className="modal fade show as-modal"
      id="changeEmailModal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{ display: "block" }}
    >
      <div className="modal-dialog modal-dialog-centered as-dialog" role="document">
        <div className="modal-content as-shell border-0">
          <button
            type="button"
            className="btn-close as-close position-absolute top-0 end-0 m-3"
            aria-label="Zamknij"
            onClick={handleCloseEmailModal}
          />

          <div className="modal-body as-body">
            <h5 className="as-title mb-1">
              <i className="bi bi-envelope-edit me-2" />
              Zmień adres e-mail
            </h5>
            <p className="as-subtitle small mb-4">
              Podaj nowe dane, aby zaktualizować adres e-mail powiązany z Twoim kontem.
            </p>

            <form onSubmit={handleSubmitChangeEmail}>
              <div className="mb-3">
                <label className="form-label small as-label">Nowy e-mail</label>
                <input
                  type="email"
                  className="form-control as-input"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label small as-label">Hasło</label>
                <input
                  type="password"
                  className="form-control as-input"
                  value={emailPassword}
                  onChange={(e) => setEmailPassword(e.target.value)}
                  required
                />
              </div>

              {emailError && <div className="alert alert-danger py-2">{emailError}</div>}
              {emailSuccess && <div className="alert alert-success py-2">{emailSuccess}</div>}

              <div className="d-flex justify-content-end gap-2 mt-3">
                <button
                  type="button"
                  className="btn as-btnSecondary rounded-pill"
                  onClick={handleCloseEmailModal}
                  disabled={emailLoading}
                >
                  Anuluj
                </button>
                <button
                  type="submit"
                  className="btn as-btnPrimary rounded-pill"
                  disabled={emailLoading}
                >
                  {emailLoading ? "Zapisywanie..." : "Zapisz zmiany"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div className="modal-backdrop fade show as-backdrop" />
  </>
)}


{/* MODAL: ZMIANA HASŁA */}
{showPasswordModal && (
  <>
    <div
      className="modal fade show as-modal"
      id="changePasswordModal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{ display: "block" }}
    >
      <div className="modal-dialog modal-dialog-centered as-dialog" role="document">
        <div className="modal-content as-shell border-0">
          <button
            type="button"
            className="btn-close as-close position-absolute top-0 end-0 m-3"
            aria-label="Zamknij"
            onClick={handleClosePasswordModal}
          />

          <div className="modal-body as-body">
            <h5 className="as-title mb-1">
              <i className="bi bi-shield-lock me-2" />
              Zmień hasło
            </h5>
            <p className="as-subtitle small mb-4">
              Upewnij się, że nowe hasło jest silne i unikalne.
            </p>

            <form onSubmit={handleSubmitChangePassword}>
              <div className="mb-3">
                <label className="form-label small as-label">Obecne hasło</label>
                <input
                  type="password"
                  className="form-control as-input"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label small as-label">Nowe hasło</label>
                <input
                  type="password"
                  className="form-control as-input"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label small as-label">Potwierdź nowe hasło</label>
                <input
                  type="password"
                  className="form-control as-input"
                  value={newPasswordConfirm}
                  onChange={(e) => setNewPasswordConfirm(e.target.value)}
                  required
                />
              </div>

              {passwordError && <div className="alert alert-danger py-2">{passwordError}</div>}
              {passwordSuccess && <div className="alert alert-success py-2">{passwordSuccess}</div>}

              <div className="d-flex justify-content-end gap-2 mt-3">
                <button
                  type="button"
                  className="btn as-btnSecondary rounded-pill"
                  onClick={handleClosePasswordModal}
                  disabled={passwordLoading}
                >
                  Anuluj
                </button>
                <button
                  type="submit"
                  className="btn as-btnPrimary rounded-pill"
                  disabled={passwordLoading}
                >
                  {passwordLoading ? "Zapisywanie..." : "Zapisz zmiany"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div className="modal-backdrop fade show as-backdrop" />
  </>
)}


{/* MODAL: USUŃ KONTO */}
{showDeleteModal && (
  <>
    <div
      className="modal fade show as-modal"
      id="deleteAccountModal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{ display: "block" }}
    >
      <div className="modal-dialog modal-dialog-centered as-dialog" role="document">
        <div className="modal-content as-shell border-0">
          <button
            type="button"
            className="btn-close as-close position-absolute top-0 end-0 m-3"
            aria-label="Zamknij"
            onClick={handleCloseDeleteModal}
          />

          <div className="modal-body as-body">
            <h5 className="as-title as-title--danger mb-1">
              <i className="bi bi-trash3 me-2" />
              Usuń konto
            </h5>
            <p className="as-subtitle small mb-4">
              Ta operacja jest <strong>nieodwracalna</strong>. Zostaną usunięte Twoje dane,
              zapisane wydarzenia i historia. Aby potwierdzić, wpisz swoje hasło.
            </p>

            <form onSubmit={handleSubmitDeleteAccount}>
              <div className="mb-3">
                <label className="form-label small as-label">Hasło</label>
                <input
                  type="password"
                  className="form-control as-input"
                  value={deletePassword}
                  onChange={(e) => setDeletePassword(e.target.value)}
                  required
                />
              </div>

              {deleteError && <div className="alert alert-danger py-2">{deleteError}</div>}

              <div className="d-flex justify-content-end gap-2 mt-3">
                <button
                  type="button"
                  className="btn as-btnSecondary rounded-pill"
                  onClick={handleCloseDeleteModal}
                  disabled={deleteLoading}
                >
                  Anuluj
                </button>
                <button
                  type="submit"
                  className="btn as-btnDanger rounded-pill"
                  disabled={deleteLoading}
                >
                  {deleteLoading ? "Usuwanie..." : "Usuń konto"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div className="modal-backdrop fade show as-backdrop" />
  </>
)}



    </>
  );
}
